import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
